import deleteModalImg from '@/assets/images/delete-modal.webp';
import { cn } from '@/lib/utils';

/**
 * The art shown in the body of every delete confirmation. This is the only
 * reference to the asset, so swapping the illustration is a one-line change
 * here rather than an edit at each confirmation.
 */
export const DeleteIllustration = ({ className }: { className?: string }) => (
    <img
        src={deleteModalImg}
        alt=""
        // Intrinsic size, so the browser reserves the box instead of
        // reflowing the modal when the art lands.
        width={948}
        height={860}
        decoding="async"
        className={cn('mx-auto h-40 w-auto object-contain sm:h-48', className)}
    />
);
